import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import LoginPage from "./pages/Login";
import DummyLoginPage from "./pages/DummyLogin";
import ConfirmationPage from "./pages/ConfirmationPage";
import TicketInfoPage from "./pages/TicketInfoPage";
import SuccessPage from "./pages/SuccessPage";
import FailedPage from "./pages/FailedPage";
import ChooseOfficerActionPage from "./pages/ChooseOfficerAction";
import PrintTicketPage from "./pages/PrintTicket";
import AuthProvider, {useAuth} from "./providers/AuthProvider";
import "react-toastify/dist/ReactToastify.css";
import {ToastContainer} from "react-toastify";
import NotFound from "./pages/NotFound";
import ErrorPage from "./pages/ErrorPage";
import TransferEventsPage from "./pages/TransferEvents";
import SuspendedPage from "./pages/SuspensionPage";
import TransferStatsPage from "./pages/TransferStats";
import ChooseMinor from "./pages/digitalAccess/ChooseMinor";
import ChooseActionPage from "./pages/digitalAccess/ChooseAction";
import CancelEventsPage from "./pages/digitalAccess/CancelEvents";
import ChosenMinorPage from "./pages/digitalAccess/ChosenMinor";
import ConfirmationPageGov from "./pages/ConfirmationPageGov";

const PrivateRoutes = ({ roles }) => {
  const { isAuth, authUser } = useAuth();
  if (isAuth) {
    return roles.includes(authUser.TICKET_ROLE) ? (
      <Outlet />
    ) : (
      <Navigate to="/tickets/error" />
    );
  } else {
    if (roles.includes("GOV_OFFICER")) {
      return <Navigate to="/tickets-gov/login-app" />;
    } else {
      return <Navigate to="/" />;
    }
  }
};

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <AuthProvider>
        <Routes>
          <Route path="/tickets/*">
            <Route index element={<Home />} />
            <Route path="login-app" element={<LoginPage />} />
            <Route path="error" element={<ErrorPage />} />
            <Route
              element={<PrivateRoutes roles={["STANDARD_USER", "OFFICER", "GOV_OFFICER"]} />}
            >
              <Route path="confirmation" element={<ConfirmationPage />} />
              <Route path="choose-action" element={<ChooseActionPage />} />
              <Route path="choose-minor" element={<ChooseMinor />} />
              <Route path="cancel-events" element={<CancelEventsPage />} />
              <Route path="selected-minor" element={<ChosenMinorPage />} />
              <Route path="success-companion" element={<SuccessPage />} />
              <Route path="success-cancel" element={<SuccessPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/ticket-office/*">
            <Route index element={<Home />} />
            <Route path="login-app" element={<LoginPage />} />
            <Route element={<PrivateRoutes roles={["OFFICER"]} />}>
              <Route path="confirmation" element={<ConfirmationPage />} />
              <Route path="choose-user" element={<ChooseOfficerActionPage />} />
              <Route path="ticket-info" element={<TicketInfoPage />} />
              <Route path="success" element={<SuccessPage />} />
              <Route path="failed" element={<FailedPage />} />
              <Route path="print-ticket" element={<PrintTicketPage />} />
              <Route path="transfer-stats" element={<TransferStatsPage />} />
              <Route path="transfer-events" element={<TransferEventsPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/tickets-gov/*">
            <Route index element={<Navigate to="/tickets-gov/login-app" />} />
            <Route path="login-app" element={<DummyLoginPage />} />
            <Route element={<PrivateRoutes roles={["GOV_OFFICER"]} />}>
	          <Route path="confirmation" element={<ConfirmationPageGov />} />
              <Route path="suspended-users" element={<SuspendedPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/" element={<Navigate to="/tickets" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer theme="colored" />
      </AuthProvider>
    </div>
  );
}

export default App;
